export default {
      id: "financial-protection-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#financial-protection",
      toString: function () {
        return this.url;
      }
    }